"use client";

import { useMemo } from "react";

import { FadeInIntersection } from "@/common/components";
import { Button } from "@/common/components-2/button";
import { MigrationLink } from "@/common/components-2/migration-link";
import { Section } from "@/common/components-2/section";
import { SectionHeading } from "@/common/components-2/section-heading";
import { useTranslations } from "@/services/i18n";

import { IconItem } from "../../_components/icon-item";
import checkIcon from "../assets/check.svg";
import list1Icon from "../assets/list1.svg";
import list2Icon from "../assets/list2.svg";
import list3Icon from "../assets/list3.svg";
import list4Icon from "../assets/list4.svg";

export function HowSection() {
  const t = useTranslations("pages.consultations.how");

  const list = useMemo(
    () => [
      {
        icon: list1Icon,
        title: t("list.1.title"),
      },
      {
        icon: list2Icon,
        title: t("list.2.title"),
      },
      {
        icon: list3Icon,
        title: t("list.3.title"),
      },
      {
        icon: list4Icon,
        title: t("list.4.title"),
      },
    ],
    [t],
  );

  const list2 = useMemo(
    () => [
      {
        icon: checkIcon,
        title: t("list_2.1.title"),
      },
      {
        icon: checkIcon,
        title: t("list_2.2.title"),
      },
      {
        icon: checkIcon,
        title: t("list_2.3.title"),
      },
      {
        icon: checkIcon,
        title: t("list_2.4.title"),
      },
    ],
    [t],
  );
  return (
    <FadeInIntersection rootMargin="0px 0px -300px 0px" delay={100} asChild animation="fadeUp">
      <Section classes={{ section: "bg-white-linen-50 py-12 md:py-16 lg:py-24" }}>
        <SectionHeading
          heading={t.rich("heading")}
          description={t("description")}
          classes={{ description: "text-center" }}
        />
        <ul className="mt-12 flex gap-16 max-lg:flex-col md:mt-14">
          {list.map(({ icon, title }, index) => (
            <IconItem
              key={title}
              icon={icon}
              title={title}
              className="flex-1 animate-fill-forwards opacity-0 group-[.animate-intersected-in]/intersected:animate-fade-right"
              style={{ animationDelay: `${index * 150}ms` }}
            />
          ))}
        </ul>
        <h3 className="mt-4 text-center font-serif text-4xl md:mt-36">{t.rich("heading_2")}</h3>
        <ul className="my-12 flex gap-16 max-lg:flex-col md:my-14">
          {list2.map(({ icon, title }, index) => (
            <IconItem
              key={title}
              icon={icon}
              title={title}
              className="flex-1 animate-fill-forwards opacity-0 group-[.animate-intersected-in]/intersected:animate-fade-right"
              style={{ animationDelay: `${index * 150}ms` }}
            />
          ))}
        </ul>
        <Button className="mx-auto max-md:w-full md:mt-6" asChild size="lg">
          <MigrationLink href="https://upacjenta.pl/konsultacje-online/wynikow">{t("button")}</MigrationLink>
        </Button>
      </Section>
    </FadeInIntersection>
  );
}
